import { Menu } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuInfo } from 'types';
import FieldInfoIcon from '../../icons/FieldInfoIcon';
import MapFieldsIcon from '../../icons/MapFieldsIcon';
import TaskListIcon from '../../icons/TaskListIcon';
import { fieldSubmenuEnum } from '../../slice/types';

interface IProps {
  selectedKey: fieldSubmenuEnum;
  onClickMenu: (clickedItem: MenuInfo) => void;
}

const FieldSubmenu = ({ onClickMenu, selectedKey }: IProps) => {
  const { t } = useTranslation();

  const menuItems = useMemo(() => {
    return [
      {
        title: t('Field.SubMenu.FieldOnMap', 'Field on the map'),
        icon: () => <MapFieldsIcon />,
        key: fieldSubmenuEnum.map,
      },
      {
        title: t('Field.SubMenu.Information', 'Information'),
        icon: () => <FieldInfoIcon />,
        key: fieldSubmenuEnum.information,
      },
      {
        title: t('Field.SubMenu.TasksInField', 'Tasks in the field'),
        icon: () => <TaskListIcon />,
        key: fieldSubmenuEnum.tasks,
      },
    ];
  }, [t]);

  return (
    <Menu mode="inline" selectedKeys={[selectedKey]} onClick={onClickMenu}>
      {menuItems.map(item => (
        <Menu.Item icon={item.icon()} key={item.key}>
          {item.title}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default FieldSubmenu;
